import React from 'react';
import CheckIcon from 'assets/svgs/actions/confirm-delete-check.svg';

export default ({formMargin, confirmDeleteMember, setDeleteConfirm}) => (
  <div
    className="d-flex text-alert align-items-center justify-content-between delete-confirm"
    style={{marginRight: formMargin}}
  >
    <p className="mb-0">
      You want to delete this category with it translations for sure?
    </p>
    <div className="d-flex">
      <button
        type="button"
        className="mr-2 cat-delete"
        onClick={() => {
          setDeleteConfirm(null);
        }}
      >
        Cancel
      </button>

      <button
        type="button"
        className="ml-auto cat-delete"
        onClick={confirmDeleteMember}
      >
        <img src={CheckIcon} alt="" className="mr-2" />
        Confirm
      </button>
    </div>
  </div>
);
